import { getMomentTz, TimeService } from "@dexteel/mesf-core";
import { useEffect, useState } from "react";

const moment = getMomentTz();

// Ticks every 30s but only re-renders when the calendar day changes in the
// plant (server) timezone — wall-display rollover for the mill overview.
export const useToday = (): string => {
	const serverTz = TimeService.getInstance().getServerTimeZone();
	const [todayKey, setTodayKey] = useState(() =>
		moment.tz(serverTz).format("YYYY-MM-DD"),
	);

	useEffect(() => {
		const id = setInterval(() => {
			setTodayKey(moment.tz(serverTz).format("YYYY-MM-DD"));
		}, 30_000);
		return () => clearInterval(id);
	}, [serverTz]);

	return todayKey;
};
